import { render, staticRenderFns } from "./DamaClients.vue?vue&type=template&id=58934ecb&"
import script from "./DamaClients.vue?vue&type=script&lang=js&"
export * from "./DamaClients.vue?vue&type=script&lang=js&"
import style0 from "./DamaClients.vue?vue&type=style&index=0&id=58934ecb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports